import React__default from 'react';
import { useStyles, useBoolean } from '@sravni/react-utils';
import modules_bbe8aac2 from '../styles/LogoCarousel.module.less.js';

const LogoCarouselItem = React__default.memo(React__default.forwardRef((props, ref) => {
    const { url, alt, className, loading = 'lazy', decoding = 'async', width = 110, height = 40, ...otherProps } = props;
    const cx = useStyles(modules_bbe8aac2);
    const [isError, setIsError] = useBoolean(false);
    if (isError) {
        return null;
    }
    return (React__default.createElement("img", { ...otherProps, ref: ref, className: cx(modules_bbe8aac2.logotype, className), onError: setIsError.on, src: url, loading: loading, decoding: decoding, width: width, height: height, alt: alt ?? '' }));
}));

export { LogoCarouselItem };
//# sourceMappingURL=LogoCarouselItem.js.map
